import {useState} from 'react';

import {badgeInk} from '../topicHue';
import {avatarFallback} from '../utils/initials';

// A face: the person's picture, or their initials on a disc in their colour when there is none
// or it fails to load. Sized in pixels, square or round.
export const Avatar = ({
    src,
    name,
    size = 32,
    shape = 'circle',
}: {
    src?: string;
    name: string;
    size?: number;
    shape?: 'circle' | 'square';
}) => {
    const [failed, setFailed] = useState(false);
    const radius = shape === 'circle' ? '50%' : `${Math.round(size * 0.28)}px`;

    if (src !== undefined && !failed) {
        return (
            <img
                className="sd-avatar"
                src={src}
                alt={name}
                width={size}
                height={size}
                loading="lazy"
                decoding="async"
                style={{width: size, height: size, borderRadius: radius}}
                onError={() => setFailed(true)}
            />
        );
    }

    const fallback = avatarFallback(name);
    return (
        <span
            className="sd-avatar sd-avatar-initial"
            role="img"
            aria-label={name}
            style={
                {
                    width: size,
                    height: size,
                    borderRadius: radius,
                    fontSize: Math.round(size * (fallback.text.length > 1 ? 0.38 : 0.44)),
                    '--sd-avatar-hue': fallback.hue,
                    '--sd-badge-ink': badgeInk(fallback.hue),
                } as React.CSSProperties
            }
        >
            {fallback.text}
        </span>
    );
};
